import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Typography } from "../../index";
import './dropdown.scss';

export const DropDownField = React.forwardRef(({
    autoFocus = false,
    disabled = false,
    id,
    label,
    name,
    onClick = () => { },
    onKeyDown = () => { },
    required = false,
    selectedId,
    selectedLabel,
    showOptions = false,
    ...inputProps
}, ref) => {

    return (
        <div className={`bsw-dropdown__input`}>
            <input
                {...inputProps}
                autoFocus={autoFocus}
                id={id}
                name={name}
                type="text"
                placeholder={label}
                className="bsw-input"
                disabled={disabled}
                value={selectedLabel}
                readOnly
                ref={ref}
                required={required}
                role="combobox"
                aria-owns={`${id}-list`}
                aria-haspopup="listbox"
                aria-expanded={showOptions}
                aria-activedescendant={selectedId}
                onClick={onClick}
                onKeyDown={onKeyDown}
            />
            {label && <label className="bsw-dropdown__label" htmlFor={id}>
                <Typography
                    type={selectedLabel ? "meta-01" : "body-02"}
                    color="$color-secondary-a2"
                    tag="div"
                >
                    {label}
                </Typography>
            </label>}
            <div className="bsw-dropdown__end">
                {/* Below ICON updates depending on showoptions */}
                <div className="bsw-dropdown__arrow">
                    <Icon name={showOptions ? "chevron-up" : "chevron-down"} color="$color-primary-a2" size="small" />
                </div>
            </div>
        </div>
    )
})

DropDownField.propTypes = {
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    required: PropTypes.bool,
    selectedId: PropTypes.string,
    selectedLabel: PropTypes.string,
    showOptions: PropTypes.bool,
}